import React from 'react';
import { useCallback } from 'react';

import { EditorHeader } from './EditorHeader';
import { EditorItem } from './EditorItem';
import { EmptyRootItem } from './EmptyRootItem';
import { NullEditorItem } from './NullEditorItem';
import Styles from './styles.module.scss';

export const JsonViewer = ({ item }: { item: object }) => {
	const parseItem = useCallback(function parseItemFn(obj: object): React.ReactNode[] {
		const typedObj = obj as Record<string, unknown>;
		const keys = Object.keys(typedObj);
		return keys.map((key, index) => {
			if (typedObj[key] === null || typedObj[key] === undefined) {
				return <NullEditorItem key={index} name={key} value={typedObj[key]} />;
			}

			if (typedObj[key] instanceof Date) {
				return <EditorItem key={index} name={key} value={typedObj[key].toISOString()} />;
			}

			const isArray = Array.isArray(typedObj[key]);
			if (typeof typedObj[key] === 'object') {
				const itemsCount =
					Object.keys(typedObj[key] as Record<string, unknown>)?.length || 0;

				return (
					<EditorHeader
						key={index}
						isCollapsed={true}
						name={key}
						isArray={isArray}
						items={itemsCount}
					>
						{parseItemFn(typedObj[key] as Record<string, unknown>)}
					</EditorHeader>
				);
			} else {
				return <EditorItem key={index} name={key} value={typedObj[key] as unknown} />;
			}
		});
	}, []);

	const parseObject = React.useMemo(() => {
		if (item === undefined || item === null) {
			return <NullEditorItem name="root" value={item} />;
		}

		const isArray = Array.isArray(item);
		const items = Object.keys(item)?.length || 0;

		if (items === 0) {
			return <EmptyRootItem isArray={isArray} />;
		}

		return (
			<EditorHeader isCollapsed={false} name="root" isArray={isArray} items={items}>
				{parseItem(item)}
			</EditorHeader>
		);
	}, [item, parseItem]);

	return (
		<div className={Styles.container}>
			<div className={Styles.editor}>{parseObject}</div>
		</div>
	);
};
